import { AxiosError } from 'axios'
import { ERROR_CODES, getErrorByStatusCode } from './ErrorCodes'
import { GenericException } from './GenericException'

const defaultErr = ERROR_CODES.PROVIDER_FAILED_UNRECOVERABLE

export class JRTAPIException extends GenericException {
  constructor(error: AxiosError<GenericException>) {
    const errorResponse = error.response?.data
    const errorByCode =
      getErrorByStatusCode(error.response?.status || defaultErr.httpStatus) || ERROR_CODES.FATAL
    const jrtGeneratedError = {
      httpStatus: error.response?.status,
      code: errorResponse?.code || errorByCode.code,
      kind: errorByCode.kind,
      subtype: errorByCode.subtype,
      businessMessage: errorByCode.businessMessage,
      developerMessage: errorResponse?.message || errorByCode.developerMessage,
      unrecoverable: !error.response?.status || error.response.status === 500,
      originalError: error,
      responseData: error.response?.data,
      description: errorResponse?.description || errorByCode.description,
      system: 'External-jrt-api',
    }
    super(jrtGeneratedError)
  }
}
